import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './CustomAccordion.module.css';

const CustomAccordion = props => {
  const { title, children, className, rootClassName, defaultOpen = false } = props;
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const classes = classNames(rootClassName || css.root, className);
  const headerClasses = classNames(css.header, {
    [css.headerOpen]: isOpen,
  });
  const contentClasses = classNames(css.content, {
    [css.contentOpen]: isOpen,
  });

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classes}>
      <button
        type="button"
        className={headerClasses}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
      >
        <span className={css.icon}>
          {isOpen ? (
            '−'
          ) : (
            <svg
              className={`${css.arrow} ${isOpen ? css.open : ''}`}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 7.5L10 12.5L15 7.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
        <span className={css.title}>{title}</span>
      </button>
      {isOpen && <div className={contentClasses}>{children}</div>}
    </div>
  );
};

CustomAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  defaultOpen: PropTypes.bool,
};

export default CustomAccordion;
